export const STORE_WEB_REQUEST_CONSOLE = 'webRequestConsoleUI';
export type STORE_WEB_REQUEST_CONSOLE = typeof STORE_WEB_REQUEST_CONSOLE;
